// @flow
import React, { createContext, useContext, useState } from 'react';

import * as numeral from 'numeral';

type Stock = {
    id: string,
    sku: string,
    name: any,
}

type Money = {
    amount: number,
    currency: string,
}

type Quantity = {
    amount: number,
    unit: string,
}

type ReturnRequestLine = {
    id: string,
    stock: Stock, 
    quantity: Quantity, 
    unitPrice: Money,
    quantityToReturn: Quantity, 
    _links: any,
}

type AppState = {
    saleOrderNo: string,
    phoneLast4: string,
    returnRequest: any,
    returnRequestLines: Array<ReturnRequestLine>,
};

type AppContextType = {
    state: AppState,
    setState: (state: AppState) => void,
};

const AppContext = createContext<AppContextType | null>(null);

export const useAppContext = (): AppContextType => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within AppProvider');
    }
    return context;
};

export const AppProvider = ({ children }: { children: React$Node }): React$Node => {
    const [state, setState] = useState<AppState>({
        saleOrderNo: '',
        phoneLast4: '',
        returnRequest: null,
        returnRequestLines: [],
    });

    return (
        <AppContext.Provider value={{ state, setState }}>
            {children}
        </AppContext.Provider>
    );
};


export const fmtAmount = (amount: number, fmt: string): string => {
    return numeral(amount).format(fmt);
}

export const fmtQuantity = (quantity?: Quantity): string => {
    const amount = (quantity && quantity.amount) ? quantity.amount : 0;
    const unit = (quantity && quantity.unit) ? quantity.unit : ' - ';
    return `${fmtAmount(amount, '0,0.00')} ${unit}`;
}


export const fmtMoney = (money?: Money): string => {
    const amount = (money && money.amount) ? money.amount : 0;
    const currency = (money && money.currency) ? money.currency : ' - ';
    return `${fmtAmount(amount, '0,0.00')} ${currency}`;
}

export const fmtI18n = (text: any): string => {
    if (!text) {
        return '';
    }
    if (text.bg) {
        return text.bg;
    }
    if (text.en) {
        return text.en;
    }
    return '';
}